import Vue from 'vue'
import VuetifyConfirm from 'vuetify-confirm'
import vuetify from '@/plugins/vuetify'
// Vue.use(VuetifyConfirm)

Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: 'Yes',
  buttonFalseText: 'No',
  color: 'warning',
  icon: 'mdi-alert',
  title: 'Warning',
  width: 350,
  property: '$confirm'
})
